module.exports = __webpack_public_path__ + "static/media/tall_pic.a06b5e5c.png";


//////////////////
// WEBPACK FOOTER
// ./images/other/tall_pic.png
// module id = 449
// module chunks = 0